<script>
  import { writable } from "svelte/store";
  import { Link, navigate, location } from "../router";
  import { getUser, logout } from "../user.js";
  import { onMount } from "svelte";
  import { info } from "../wedding.js";
  import { extractParams } from "../utils.js";
  import {
    Background,
    Font,
    ForegroundColor,
    Padding,
    Center,
    Frame,
    Border,
  } from "../component/modifier";
  import { HStack, VStack, Spacer, MediaQuery } from "../component/layout";
  import { Button, Label, Logo } from "../component/widget";

  import CookieConsent from "../component/CookieConsent.svelte";
  import Header from "../component/Header.svelte";
  import Copyright from "../component/Copyright.svelte";
  import CountDown from "../component/CountDown.svelte";
  import Scheduler from "../component/Scheduler.svelte";
  import GuestsList from "../component/GuestsPortlet.svelte";
  import TableMap from "../component/TableMap.svelte";
  import Blog from "../component/Blog.svelte";
  import Rsvp from "../component/RsvpPortlet.svelte";
  import Budget from "../component/Budget.svelte";
  import Champiz from "../component/Champiz.svelte";
  import Message from "../component/MessagePortlet.svelte";

  let wedding = writable(undefined);

  export let wedding_guid;

  let userRequest;

  onMount(() => {
    console.log("Dashboard on mount");
    userRequest = getUser();
    const unsubscribe = userRequest.subscribe((promise) => {
      promise.then((u) => {
        info(wedding_guid, true)
          .then((r) => {
            wedding.set(r.data);
          })
          .catch((e) => {
            wedding.set(undefined);
            logout().then(() => navigate("/"));
          });
      });
    });

    return () => {
      console.log("Dashboard destroy");
      unsubscribe();
    };
  });
</script>

<main>
  <CookieConsent />
  <Header>
    <div slot="left">
      <Button action={() => navigate(`#/select`)}>
        <Label text="Changer de mariage" icon="sync" borderLeft h="48px" />
      </Button>
    </div>
  </Header>
  <Background color="var(--primary-color)">
    {#if $wedding}
      <HStack grow alignment="stretch">
        <MediaQuery query="(min-width: 481px)">
          <div>
            <Background color="var(--primary-color)">
              <VStack alignment="center">
                <CountDown name={$wedding.name} date={$wedding.wedding_date} />
                <Scheduler id={$wedding.guid} />
              </VStack>
            </Background>
          </div>
        </MediaQuery>
        <article>
          <MediaQuery query="(max-width: 480px)">
            <h1>{$wedding.name}</h1>
            <span class="date">{$wedding.wedding_date}</span>
          </MediaQuery>
          <Message guid={$wedding.guid} />
          <GuestsList guid={$wedding.guid} />
          <Budget guid={$wedding.guid} />
          <Rsvp guid={$wedding.guid} />
          <TableMap guid={$wedding.guid} />
          <Blog guid={$wedding.guid} />
          <Champiz guid={$wedding.guid} />
        </article>
      </HStack>
    {/if}
  </Background>
  <Copyright company="KiwisApp" />
</main>

<style>
  article {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  h1 {
    color: white;
  }
  .date {
    color: var(--secondary-light-color);
  }
  @media (min-width: 481px) {
    article {
      flex-direction: row;
      width: calc(100% - 270px);
    }

    article > :global(*) {
      margin: 1em;
      flex: 0 1 25%;
    }
  }
</style>
